import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import EngagementRings from './EngagementRings';
import ExclusiveCollection from './ExclusiveCollection';
import MetalType from './MetalType';
import RingShopByStyle from './RingShopByStyle';
import { Accordion, AccordionDetails, AccordionSummary, Breadcrumbs, Typography } from '@mui/material';
import { Col, Row, Container } from 'react-bootstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';
import Customer from '../../Front/Customer';
import DreamRings from './DreamRings';
import WhyDiamondDflForEngRing from './WhyDiamondDflForEngRing';
import ShopForFineDiamond from './ShopForFineDiamond';
import ShopByShap from './ShopByShap';
import TrendingNow from './TrendingNow';
import { Diamond } from '@mui/icons-material';
import DiamondEngamentRing from './DiamondEngamentRing';

const EngagmentStaticPage = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const [expanded, setExpanded] = React.useState(true);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
      </Helmet>
      <div className="dfl_engament_ring_staicpage_section">
        <EngagementRings />
        <TrendingNow/>
         <RingShopByStyle /> 
        <ShopByShap/>
        <MetalType />
        <DreamRings />
      <DiamondEngamentRing/>
        <WhyDiamondDflForEngRing />
        <Customer />
        <ShopForFineDiamond />
        {/* FAQs */}
        <Container>
          <Row>
            <Col sm={12} >
              <div className="rcs_privacy_content rcs_mobile_menu mb-5 w-100 top_heading_metal eng_faq_title new">
                {/* <h3>Shop Diamond Engagement Rings Toronto at DFL</h3> */}
                <div className="rcs_faq_accordion mb-5">
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      {/* <Typography> */}
                      <h2>Shop Diamond Engagement Rings Toronto at DFL</h2>
                      {/* </Typography> */}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <p className='pt-2'>Diamonds For Less has been the leading seller the number 1 trusted name of diamond <strong>engagement rings in Toronto</strong> since 1985. With over 4 Decades of experience and expertise and thousands of in-stock ring styles, we bring a wide range of variety to the table. Whether you are looking for a classic round diamond ring, our latest signature designs, or something more contemporary as a Toi et Moi ring, our collection of <strong>engagement rings in Toronto</strong> has something for everyone.
                        </p>
                        <p>Each ring in our collection is curated using the finest quality diamonds and metals to ensure we bring your vision to life at the lowest wholesale prices guaranteed. We also specialise in bespoke engagement rings, so you can customise your dream ring with our diamond experts and design team, right from the centre stone to the metals and every minute detail in between. With one of the largest in-stock selections of earth-mined and lab-loose diamonds, our diamond collection caters to every style and preference.</p>
                        <p>You can select a diamond ring with an earth-mined diamond, a traditional choice for engagement rings for centuries, or opt for a lab-grown diamond, a modern alternative that can be customized to your exact preferences down to the last detail.</p>
                        <p>Moreover, our ring collection is curated with all budgets in mind. So, along with the variety of ring settings and diamond shapes, you will also come across rings in various price ranges. While there are many reasons why you should shop for your dream ring with us, the number one reason is that we are the premier destination for <strong>engagement rings in Toronto</strong>, with all our rings available at wholesale prices. So, if you have a ring in mind, visit Diamonds For Less to let us make your dreams come true.</p>
                        <p>Contact us today to design your bespoke ring or shop for your dream ring in our collection.</p>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col sm={12} >
              <div className="rcs_privacy_content rcs_mobile_menu mb-5 w-100 top_heading_metal eng_faq_title">
                <h3>Engagement Rings FAQs</h3>
                <div className="rcs_faq_accordion mb-5">
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <Typography>Where to buy engagement rings toronto?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>Diamonds For Less is one of Toronto's leading <a href='https://www.google.com/maps/place/Diamonds+For+Less/@43.6540743,-79.3794165,15z/data=!4m6!3m5!1s0x89d4cb34a5006187:0x7d775a6a5641f2d!8m2!3d43.6540743!4d-79.3794165!16s%2Fg%2F1tdkc18k?entry=ttu' target='_blank'> jewellery stores </a> for engagement rings. With thousands of ring styles in our collection, we have a ring to suit every style and budget. Choose from a wide range of <NavLink to="/ringsettings">engagement rings</NavLink> , all available at wholesale prices.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                      <Typography>What is the average cost of an engagement ring?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>The average cost of an engagement ring can vary widely, but it often falls in the range of $5,000 to $7,000. However, it's essential to choose a ring that fits your budget and financial situation.</Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                      <Typography>How do I determine the right ring size for my partner?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>The best way to find the correct ring size is to secretly borrow one of your partner's rings that they wear on the ring finger and have it sized by DFL. Or, you can ask their friends or family for help. Alternatively present the ring at a standard size and then have the DFL experts adjust it accordingly at no charge.</Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
                      <Typography>What are the most popular engagement ring metals?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        The most popular metals for engagement rings are{' '}
                        <Link to="/ringsettings/Platinum" className="eggemtlinkss">
                          platinum
                        </Link>
                        ,
                        <Link to="/ringsettings/White-Gold" className="eggemtlinkss">
                          white gold
                        </Link>
                        ,
                        <Link to="/ringsettings/Yellow-Gold" className="eggemtlinkss">
                          yellow gold
                        </Link>
                        , and
                        <Link to="/ringsettings/Rose-Gold" className="eggemtlinkss">
                          rose gold
                        </Link>
                        . Each has its unique appearance and durability.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header">
                      <Typography>What are the different engagement ring styles?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        There are various styles to choose from, including
                        <Link to="/ringsettings/Solitaire" className="eggemtlinkss">
                          solitaire
                        </Link>
                        ,
                        <Link to="/ringsettings/Halo" className="eggemtlinkss">
                          halo
                        </Link>
                        ,
                        <Link to="/ringsettings/Vintage" className="eggemtlinkss">
                          vintage
                        </Link>
                        ,
                        <Link to="/ringsettings/Three%20stone" className="eggemtlinkss">
                          three-stone
                        </Link>{' '}
                        , and more. The choice depends on your partner's taste and preference.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5a-content" id="panel5a-header">
                      <Typography>What is the difference between custom and non-custom made engagement rings?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        Custom-Made Engagement Rings: These rings are designed and created specifically for an individual based on their preferences and input. Customers can work closely with our diamond experts to select the diamond, choose the metal, and collaborate on a unique design.
                        <Link to="/custom-jewelry-toronto-2" className="eggemtlinkss">
                          {' '}
                          Custom rings
                        </Link>{' '}
                        are highly personalized and often one-of-a-kind, making them a perfect choice for those who want a unique piece of Jewellery that reflects their style and story.
                        <br />
                        Non-Custom (Mass-Produced) Engagement Rings: Non-custom engagement rings are typically pre-designed and mass-produced by Jewellery manufacturers. They are readily available in Jewellery stores and online retailers. While there may be some variation in terms of metal choice, stone size, and minor design elements, these rings are generally not tailored to an individual's specific preferences.
                        <br />
                        In summary, custom-made engagement rings offer a high degree of personalization and uniqueness, whereas non-custom rings are pre-designed and mass-produced. At DFL every engagement ring is tailor made to the clients budget, taste and wish list without the exorbitant retail markups and lengthy timelines. Our diamond experts can deliver a custom ring typically within a day and at the lowest wholesale prices GUARANTEED.
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6a-content" id="panel6a-header">
                      <Typography>Do I need to get an engagement ring and a wedding band?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>While most people opt for both, which includes both the engagement ring and the wedding band, designed to complement each other. Others just prefer to purchase one ring to act as both a wedding band and engagement ring.</Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header">
                      <Typography>How should I plan the surprise proposal with the engagement ring?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>Consider your partner's personality and preferences. Some may prefer a private, intimate proposal, while others would appreciate a public event. Ensure the timing and location are meaningful to your relationship.</Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* FAQs ends */}



        {/* <ExclusiveCollection /> */}



      </div>
    </>
  );
};

export default EngagmentStaticPage;
